// startup
// Load entry module and return exports
__webpack_require__("./blocks/src/blocks.js");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./blocks/src/editor.scss");
var __webpack_exports__ = __webpack_require__("./blocks/src/style.scss");
